import React from "react";

/**
 * DS Stepper — figma 4776:141215 (2단계 모달 "연동지점 선택" 헤더 아래 단계 표시).
 *   컨테이너: px24 py20 gap 32, bg #F9FAFB, border-bottom Border/Default (66h)
 *   step: gap 12 / 번호 원 26×26 SemiBold 14/22 — 현재 = BG/Accent + white, 그 외 = white + Text/Primary
 *   라벨 SemiBold 16/26 Text/Secondary
 * 지난 단계도 비활성과 동일하게 그린다.
 *
 * @param {object} props
 * @param {Array<React.ReactNode>} props.steps - 라벨 배열
 * @param {number} props.current - 현재 단계 index (0-base)
 * @param {string} [props.className]
 */
const DSStepper = ({ steps = [], current = 0, className = "" }) => (
  <div className={`ds-stepper ${className}`} role="list">
    {steps.map((label, idx) => (
      <div
        key={idx}
        role="listitem"
        className={`ds-stepper__step${idx === current ? " ds-stepper__step--active" : ""}`}
        aria-current={idx === current ? "step" : undefined}
      >
        <span className="ds-stepper__num">{idx + 1}</span>
        <span className="ds-stepper__label">{label}</span>
      </div>
    ))}
  </div>
);

export default React.memo(DSStepper);
